import React from 'react';
import PropTypes from 'prop-types';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Popover from '@mui/material/Popover';
import Snackbar from '@mui/material/Snackbar';

import ShareIconUrl from '../../../../resources/icons/icon-share-black.svg';
import ShareIconMobileUrl from '../../../../resources/icons/icon-share-black.svg';

import { FACEBOOK_SHARE_PARAMS, X_SHARE_PARAMS, LINKEDIN_SHARE_PARAMS, SHARE_TEXT, SHARE_TEXT_FACEBOOK, SHARE_TEXT_COPYPASTE, SHARE_TEXT_LINKEDIN, SHARE_TEXT_X, SHARE_TEXT_COPYPASTE_SUCCESS } from '../../../../config';

class ShareButton extends React.Component {
  constructor(props) {
    super(props);
    
    this.state = {
      shareAnchorEl: null,
      clipboardNotificationOpen: false,
    }
  }

  render() {
    const { classes, isMobile } = this.props;
    const { shareAnchorEl, clipboardNotificationOpen } = this.state;
    return (
      <>
        <ListItem key="share" className={classes.listItem} disablePadding sx={{ justifyContent: isMobile ? 'center' : 'flex-start' }}>
          <ListItemButton className={isMobile ? classes.shareAndDownloadMobileButton : null} onClick={evt => this.setState({ shareAnchorEl: evt.currentTarget })} sx={{ flexGrow: isMobile ? 0 : 1 }}>
            <ListItemIcon>
              <img className={classes.menuIcon} src={isMobile ? ShareIconMobileUrl : ShareIconUrl} alt={SHARE_TEXT} />
            </ListItemIcon>
            <ListItemText className={`${classes.drawerLabel}`} primary={<Typography variant="h4">{SHARE_TEXT}</Typography>} />
          </ListItemButton>
        </ListItem>
        <Popover
          className={classes.sharePopper}
          open={Boolean(shareAnchorEl)}
          anchorEl={shareAnchorEl}
          anchorOrigin={{
            horizontal: 'center',
            vertical: 'center'
          }}
          onClose={() => this.setState({ shareAnchorEl: null })}
          elevation={2}
        >
          <List disablePadding>
            {!isMobile && (
              <ListItem key="copy" disablePadding disableGutters>
                <ListItemButton onClick={async () => {
                  try {
                    await navigator.clipboard.writeText(window.location.href);
                    if (window.umami) {
                      window.umami.track('Portfolio RA - Share');
                      window.umami.track('Portfolio RA - Share - Copy/Paste');
                    }
                  } catch(e) {}
                  this.setState({ clipboardNotificationOpen: true, shareAnchorEl: null });
                }}>
                  <ListItemText className={classes.drawerLabel} primary={<Typography variant="h5">{SHARE_TEXT_COPYPASTE}</Typography>} />
                </ListItemButton>
              </ListItem>
            )}
            <ListItem key="fb" disablePadding disableGutters>
              <ListItemButton onClick={() => {
                  if (window.umami) {
                    window.umami.track('Portfolio RA - Share');
                    window.umami.track('Portfolio RA - Share - Facebook');
                  }
                }}>
                <ListItemText className={classes.drawerLabel} primary={(
                  <a style={{ textDecoration: 'none', color: '#000' }} href={FACEBOOK_SHARE_PARAMS} target="_blank" rel="noopener noreferrer">
                    <Typography variant="h5">{SHARE_TEXT_FACEBOOK}</Typography>
                  </a>
                )} />
              </ListItemButton>
            </ListItem>
            <ListItem key="x" disablePadding disableGutters>
              <ListItemButton onClick={() => {
                window.open(X_SHARE_PARAMS, "pop", "width=600, height=400, scrollbars=no");
                if (window.umami) {
                  window.umami.track('Portfolio RA - Share');
                  window.umami.track('Portfolio RA - Share - X');
                }
              }}>
                <ListItemText className={classes.drawerLabel} primary={<Typography variant="h5">{SHARE_TEXT_X}</Typography>} />
              </ListItemButton>
            </ListItem>
            <ListItem key="linkedin" disablePadding disableGutters>
              <ListItemButton onClick={() => {
                window.open(LINKEDIN_SHARE_PARAMS, "pop", "width=600, height=400, scrollbars=no");
                if (window.umami) {
                  window.umami.track('Portfolio RA - Share');
                  window.umami.track('Portfolio RA - Share - LinkedIn');
                }
              }}>
                <ListItemText className={classes.drawerLabel} primary={<Typography variant="h5">{SHARE_TEXT_LINKEDIN}</Typography>} />
              </ListItemButton>
            </ListItem>
          </List>
        </Popover>
        <Snackbar
          open={clipboardNotificationOpen}
          autoHideDuration={3000}
          onClose={() => this.setState({ clipboardNotificationOpen: false })}
          message={SHARE_TEXT_COPYPASTE_SUCCESS}
        />
      </>
    );
  }
}

ShareButton.propTypes = {
  classes: PropTypes.object.isRequired,
  // props
  isMobile: PropTypes.bool,
};

export default ShareButton;
